import React from 'react';
import { TruckIcon, LayersIcon, UsersIcon, SettingsIcon } from 'lucide-react';
import { TextReveal } from './ui/Reveal';
const FEATURES = [{
  title: 'Fast Delivery',
  description: 'Get quicker turnarounds on design projects without sacrificing quality at a way better price on your wallet.',
  icon: TruckIcon
}, {
  title: 'Consistency',
  description: 'Ensure a consistent brand identity with regular design output.',
  icon: LayersIcon
}, {
  title: 'Diversity',
  description: 'Access to a variety of styles and expertise from a pool of creative professionals.',
  icon: UsersIcon
}, {
  title: 'Flexibility',
  description: 'Adapt the service to cover a wide range of design tasks as needed.',
  icon: SettingsIcon
}];
export function Differentiators() {
  return <section className="relative z-10 w-full bg-[#F2F2F2] px-5 py-20 lg:px-8 lg:py-24" data-id="element-33" data-mp="2jscf82p0ub66">
      <div className="mx-auto w-full max-w-shell" data-id="element-34" data-mp="2oq44eoya7j6o">
        <h2 className="max-w-[720px] text-3xl font-semibold leading-tight text-[#2D2D2D] lg:text-[40px] lg:leading-[48.8px]" data-id="element-35" data-mp="bokcpw03bzrq">
          <TextReveal data-id="element-36" data-mp="7oaa8tbibrhm">
            Here are a few things we do that others really just don't.
          </TextReveal>
        </h2>

        <ul className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-37" data-mp="2mb5pg416oj3">
          {FEATURES.map(feature => {
          const Icon = feature.icon;
          return <li key={feature.title} className="flex flex-col gap-4 rounded-2xl bg-white p-6 shadow-sm" data-id="element-38" data-mp="3owx7zb4uicf6">
                <Icon className="h-6 w-6 text-[#0000FE]" aria-hidden="true" data-id="element-39" data-mp="3g2sj2x99vb2a" />
                <h3 className="text-lg font-semibold text-[#2D2D2D]" data-id="element-40" data-mp="3g0o67pteb1pv">
                  {feature.title}
                </h3>
                <p className="text-sm leading-6 text-[#6F6F6F]" data-id="element-41" data-mp="365e657mk54eq">
                  {feature.description}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}